<template>
    <div @change="$emit('update:modelValue', form)">
        <!-- Verfahren -->
        <card>
            <card-header>
                <card-overline><translate>Verfahren</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Zerpanen</translate></p>
                    <template v-for="(value, name, index) in form.methods['zerspanen']">
                        <form-checkbox v-if="name !== 'zerspanen_andere_c' && name !== 'zerspanen_andere' " :key="index"
                                       v-model:checked="form.methods['zerspanen'][name]" :id="name"
                                       :option="labels.methodLabels['_zerspanen'][name]"/>
                        <form-checkbox v-if="name === 'zerspanen_andere_c'" :key="index"
                                       v-model:checked="form.methods['zerspanen'][name]" :id="name"
                                       :option="labels.methodLabels['_zerspanen'][name]"/>
                        <form-input v-if="name === 'zerspanen_andere'" :key="index"
                                    v-model="form.methods['zerspanen'][name]" :id="name"
                                    :label="labels.methodLabels['_zerspanen'][name]" class="form-element--custom"/>
                    </template>

                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Trennen</translate></p>
                    <template v-for="(value, name, index) in form.methods['trennen']">
                        <form-checkbox v-if="name !== 'trennen_andere_c' && name !== 'trennen_andere' " :key="index"
                                       v-model:checked="form.methods['trennen'][name]" :id="name"
                                       :option="labels.methodLabels['_trennen'][name]"/>
                        <form-checkbox v-if="name === 'trennen_andere_c'" :key="index"
                                       v-model:checked="form.methods['trennen'][name]" :id="name"
                                       :option="labels.methodLabels['_trennen'][name]"/>
                        <form-input v-if="name === 'trennen_andere'" :key="index"
                                    v-model="form.methods['trennen'][name]" :id="name"
                                    :label="labels.methodLabels['_trennen'][name]" class="form-element--custom"/>
                    </template>
                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Urformen</translate></p>
                    <template v-for="(value, name, index) in form.methods['urformen']">
                        <form-checkbox v-if="name !== 'urformen_andere_c' && name !== 'urformen_andere' " :key="index"
                                       v-model:checked="form.methods['urformen'][name]" :id="name"
                                       :option="labels.methodLabels['_urformen'][name]"/>
                        <form-checkbox v-if="name === 'urformen_andere_c'" :key="index"
                                       v-model:checked="form.methods['urformen'][name]" :id="name"
                                       :option="labels.methodLabels['_urformen'][name]"/>
                        <form-input v-if="name === 'urformen_andere'" :key="index"
                                    v-model="form.methods['urformen'][name]" :id="name"
                                    :label="labels.methodLabels['_urformen'][name]" class="form-element--custom"/>
                    </template>
                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Umformen</translate></p>
                    <template v-for="(value, name, index) in form.methods['umformen']">
                        <form-checkbox v-if="name !== 'umformen_andere_c' && name !== 'umformen_andere' " :key="index"
                                       v-model:checked="form.methods['umformen'][name]" :id="name"
                                       :option="labels.methodLabels['_umformen'][name]"/>
                        <form-checkbox v-if="name === 'umformen_andere_c'" :key="index"
                                       v-model:checked="form.methods['umformen'][name]" :id="name"
                                       :option="labels.methodLabels['_umformen'][name]"/>
                        <form-input v-if="name === 'umformen_andere'" :key="index"
                                    v-model="form.methods['umformen'][name]" :id="name"
                                    :label="labels.methodLabels['_umformen'][name]" class="form-element--custom"/>
                    </template>
                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Fügen</translate></p>
                    <template v-for="(value, name, index) in form.methods['fuegen']">
                        <form-checkbox v-if="name !== 'fuegen_andere_c' && name !== 'fuegen_andere' " :key="index"
                                       v-model:checked="form.methods['fuegen'][name]" :id="name"
                                       :option="labels.methodLabels['_fuegen'][name]"/>
                        <form-checkbox v-if="name === 'fuegen_andere_c'" :key="index"
                                       v-model:checked="form.methods['fuegen'][name]" :id="name"
                                       :option="labels.methodLabels['_fuegen'][name]"/>
                        <form-input v-if="name === 'fuegen_andere'" :key="index" v-model="form.methods['fuegen'][name]"
                                    :id="name" :label="labels.methodLabels['_fuegen'][name]"
                                    class="form-element--custom"/>
                    </template>
                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Beschichten</translate></p>
                    <template v-for="(value, name, index) in form.methods['beschichten']">
                        <form-checkbox v-if="name !== 'beschichten_andere_c' && name !== 'beschichten_andere' "
                                       :key="index" v-model:checked="form.methods['beschichten'][name]" :id="name"
                                       :option="labels.methodLabels['_beschichten'][name]"/>
                        <form-checkbox v-if="name === 'beschichten_andere_c'" :key="index"
                                       v-model:checked="form.methods['beschichten'][name]" :id="name"
                                       :option="labels.methodLabels['_beschichten'][name]"/>
                        <form-input v-if="name === 'beschichten_andere'" :key="index"
                                    v-model="form.methods['beschichten'][name]" :id="name"
                                    :label="labels.methodLabels['_beschichten'][name]" class="form-element--custom"/>
                    </template>
                </div>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Sonstiges</translate></p>
                    <template v-for="(value, name, index) in form.methods['sonstiges']">
                        <form-checkbox v-if="name !== 'sonstiges_andere_c' && name !== 'sonstiges_andere' " :key="index"
                                       v-model:checked="form.methods['sonstiges'][name]" :id="name"
                                       :option="labels.methodLabels['_sonstiges'][name]"/>
                        <form-checkbox v-if="name === 'sonstiges_andere_c'" :key="index"
                                       v-model:checked="form.methods['sonstiges'][name]" :id="name"
                                       :option="labels.methodLabels['_sonstiges'][name]"/>
                        <form-input v-if="name === 'sonstiges_andere'" :key="index"
                                    v-model="form.methods['sonstiges'][name]" :id="name"
                                    :label="labels.methodLabels['_sonstiges'][name]" class="form-element--custom"/>
                    </template>
                </div>
            </card-content>
        </card>

        <!-- Anforderung -->
        <card>
            <card-header>
                <card-overline><translate>Anforderung</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Anforderung</translate></p>
                    <form-checkbox
                        v-for="(value, name, index) in form.requirements" :key="index"
                        v-model:checked="form.requirements[name]" :id="name"
                        :option="labels.requirementLabels['_' + name]">
                    </form-checkbox>
                </div>
            </card-content>
        </card>

        <!-- Bauteilmaße -->
        <card>
            <card-header>
                <card-overline><translate>Bauteilmaße</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-2">
                    <p class="subtitle-1"><translate>Rundteile</translate></p>
                    <form-input v-for="(value, name, index) in form.dimensions['rundteile']" :key="index"
                                v-model="form.dimensions['rundteile'][name]" :id="name"
                                :label="labels.dimensionLabels['_rundteile'][name]"/>
                </div>

                <div class="abilities--group abilities--group-2">
                    <p class="subtitle-1"><translate>Sonstige / Freiform</translate></p>
                    <form-input v-for="(value, name, index) in form.dimensions['sonstige_freiform']" :key="index"
                                v-model="form.dimensions['sonstige_freiform'][name]" :id="name"
                                :label="labels.dimensionLabels['_sonstige_freiform'][name]"/>
                </div>
            </card-content>
        </card>

        <!-- Werkstoffe -->
        <card>
            <card-header>
                <card-overline><translate>Werkstoffe</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Werkstoffe</translate></p>
                    <form-checkbox
                        v-for="(value, name, index) in form.materials" :key="index"
                        v-model:checked="form.materials[name]" :id="name"
                        :option="labels.materialLabels['_' + name]">
                    </form-checkbox>
                </div>
            </card-content>
        </card>

        <!-- Wärmebehandlung -->
        <card>
            <card-header>
                <card-overline><translate>Wärmebehandlung</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-4">
                    <p class="subtitle-1"><translate>Wärmebehandlung</translate></p>
                    <template v-for="(value, name, index) in form.treatments">
                        <form-checkbox v-if="name !== 'treatment_sonstiges_c' && name !== 'sonstiges' " :key="index"
                                       v-model:checked="form.treatments[name]" :id="name"
                                       :option="labels.treatmentLabels['_' + name]"/>
                        <form-checkbox v-if="name === 'treatment_sonstiges_c'" :key="index"
                                       v-model:checked="form.treatments[name]" :id="name"
                                       :option="labels.treatmentLabels['_' + name]"/>
                        <form-input v-if="name === 'sonstiges'" :key="index"
                                    v-model="form.treatments[name]" :id="name"
                                    :label="labels.treatmentLabels['_' + name]" class="form-element--custom"/>
                    </template>

                </div>
            </card-content>
        </card>

        <!-- Qualitätskriterien -->
        <card>
            <card-header>
                <card-overline><translate>Qualitätskriterien</translate></card-overline>
            </card-header>
            <card-content>
                <div class="row">
                    <div class="col col-4">
                        <div class="abilities--group abilities--group-2">
                            <p class="subtitle-1"><translate>Rauheit</translate></p>
                            <form-input v-for="(value, name, index) in form.qualityCriteria['rauheit']" :key="index"
                                        v-model="form.qualityCriteria['rauheit'][name]" :id="name"
                                        :label="labels.qualityCriteriaLabels['_rauheit'][name]"/>
                        </div>
                    </div>
                    <div class="col col-4">
                        <div class="abilities--group">
                            <p class="subtitle-1"><translate>Allgemeintoleranzen</translate>n</p>
                            <template v-for="(value, name, index) in form.qualityCriteria['allgemeintoleranzen']">
                                <form-select v-if="index === 0" id="iso_2768_1"
                                             v-model="form.qualityCriteria['allgemeintoleranzen'][name]"
                                             :options="$page.props.abilities.qualityCriteria.allgemeintoleranzen.iso_2768_1"
                                             :key="index"
                                             :label="this.$gettext('Längen u. Winkel (nach ISO 2768-1) auswählen')"/>
                                <form-select v-if="index === 1" id="iso_2768_2"
                                             v-model="form.qualityCriteria['allgemeintoleranzen'][name]"
                                             :options="$page.props.abilities.qualityCriteria.allgemeintoleranzen.iso_2768_2"
                                             :key="index"
                                             :label="this.$gettext('Form u. Lage (nach ISO 2768-2) auswählen')"/>
                            </template>
                        </div>
                    </div>
                    <div class="col col-4">
                        <div class="abilities--group">
                            <p class="subtitle-1"><translate>ISO-Toleranzen</translate></p>
                            <template v-for="(value, name, index) in form.qualityCriteria['iso_toleranzen']">
                                <form-select v-if="index === 0" id="iso_toleranzen"
                                             v-model="form.qualityCriteria['iso_toleranzen'][name]"
                                             :options="$page.props.abilities.qualityCriteria.iso_toleranzen"
                                             :key="index"
                                             :label="this.$gettext('Toleranz auswählen')"/>
                            </template>
                        </div>
                    </div>
                </div>


            </card-content>
        </card>

        <!-- kritische Formtoleranzen -->
        <card>
            <card-header>
                <card-overline><translate>kritische Formtoleranzen</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-2">
                    <form-input v-for="(value, name, index) in form.formTolerance" :key="index"
                                v-model="form.formTolerance[name]" :id="name"
                                :label="labels.formToleranceLabels['_' + name]"/>
                </div>
            </card-content>
        </card>

        <!-- kritische Lagetoleranzen -->
        <card>
            <card-header>
                <card-overline><translate>kritische Lagetoleranzen</translate></card-overline>
            </card-header>
            <card-content>
                <div class="abilities--group abilities--group-2">
                    <form-input v-for="(value, name, index) in form.positionTolerance" :key="index"
                                v-model="form.positionTolerance[name]" :id="name"
                                :label="labels.positionToleranceLabels['_' + name]"/>
                </div>
            </card-content>
        </card>
    </div>
</template>

<script>
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormInput from '@partfactory/Shared/Form/FormInput';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import FormSelect from '@partfactory/Shared/Form/FormSelect';

export default {
    name: 'ProducerAbilities',
    components: {FormSelect, CardOverline, CardContent, CardHeader, Card, FormInput, FormCheckbox},
    props: [
        'modelValue',
        'producerUser',
        'abilities',
    ],
    data() {
        const form = {
            methods: {},
            requirements: {},
            dimensions: {},
            materials: {},
            treatments: {},
            qualityCriteria: {},
            formTolerance: {},
            positionTolerance: {},
        };
        const labels = {
            methodLabels: {},
            requirementLabels: {},
            dimensionLabels: {},
            materialLabels: {},
            treatmentLabels: {},
            qualityCriteriaLabels: {},
            formToleranceLabels: {},
            positionToleranceLabels: {},
        };
        return {form, labels};
    },
    emits: ['update:modelValue'],
    mounted() {
        // define methods
        let items = {};
        let labels = {};
        for (const [key] of Object.entries(this.abilities.methods)) {
            items[key] = {};
            this.abilities.methods[key].forEach((method) => {
                try {
                    if (method[2] !== 'custom')
                        items[key][method[0]] = this.producerUser.abilities?.methods[key][method[0]] ? true : false;
                    else
                        items[key][method[0]] = this.producerUser.abilities?.methods[key][method[0]] ? this.producerUser.abilities?.methods[key][method[0]] : '';
                } catch (e) {
                    items[key][method[0]] = method[2] !== 'custom' ? false : '';
                }
            });
            labels['_' + key] = {};
            this.abilities.methods[key].forEach((method) => {
                labels['_' + key][method[0]] = this.$gettext(method[1]);
            });
        }

        this.form.methods = items;
        this.labels.methodLabels = labels;

        // define requirements
        items = {};
        labels = {};
        this.abilities.requirements.forEach((requirement) => {
            try {
                items[requirement[0]] = this.producerUser.abilities.requirements[requirement[0]] ? true : false;
            } catch (e) {
                items[requirement[0]] = false;
            }
            labels['_' + requirement[0]] = this.$gettext(requirement[1]);
        });

        this.form.requirements = items;
        this.labels.requirementLabels = labels;

        // define dimensions
        items = {};
        labels = {};
        for (const [key] of Object.entries(this.abilities.dimensions)) {
            items[key] = {};
            this.abilities.dimensions[key].forEach((dimension) => {
                try {
                    items[key][dimension[0]] = this.producerUser.abilities?.dimensions[key][dimension[0]] ? this.producerUser.abilities?.dimensions[key][dimension[0]] : '';
                } catch (e) {
                    items[key][dimension[0]] = '';
                }
            });
            labels['_' + key] = {};
            this.abilities.dimensions[key].forEach((dimension) => {
                labels['_' + key][dimension[0]] = dimension[1];
            });
        }

        this.form.dimensions = items;
        this.labels.dimensionLabels = labels;

        // define materials
        items = {};
        labels = {};
        this.abilities.materials.forEach((material) => {
            try {
                items[material[0]] = this.producerUser.abilities.materials[material[0]] ? true : false;
            } catch (e) {
                items[material[0]] = false;
            }
            labels['_' + material[0]] = this.$gettext(material[1]);
        });

        this.form.materials = items;
        this.labels.materialLabels = labels;

        // define treatments
        items = {};
        labels = {};
        this.abilities.treatments.forEach((treatment) => {
            try {
                if (treatment[2] !== 'custom')
                    items[treatment[0]] = this.producerUser.abilities?.treatments[treatment[0]] ? true : false;
                else
                    items[treatment[0]] = this.producerUser.abilities?.treatments[treatment[0]] ? this.producerUser.abilities?.treatments[treatment[0]] : '';
            } catch (e) {
                items[treatment[0]] = treatment[2] !== 'custom' ? false : '';
            }
            labels['_' + treatment[0]] = this.$gettext(treatment[1]);
        });

        this.form.treatments = items;
        this.labels.treatmentLabels = labels;

        // define qualityCriteria
        items = {
            'rauheit': {},
            'allgemeintoleranzen': {},
            'iso_toleranzen': {},
        };
        labels = {
            '_rauheit': {},
        };
        this.abilities.qualityCriteria['rauheit'].forEach((roughness) => {
            try {
                items['rauheit'][roughness[0]] = this.producerUser.abilities?.qualityCriteria['rauheit'][roughness[0]] ? this.producerUser.abilities?.qualityCriteria['rauheit'][roughness[0]] : '';
            } catch (e) {
                items['rauheit'][roughness[0]] = '';
            }
            labels['_rauheit'][roughness[0]] = roughness[1];
        });
        try {
            items['allgemeintoleranzen'][0] = this.producerUser?.abilities?.qualityCriteria['allgemeintoleranzen'][0] ? this.producerUser?.abilities?.qualityCriteria['allgemeintoleranzen'][0] : '';
        } catch (e) {
            items['allgemeintoleranzen'][0] = '';
        }
        try {
            items['allgemeintoleranzen'][1] = this.producerUser?.abilities?.qualityCriteria['allgemeintoleranzen'][1] ? this.producerUser?.abilities?.qualityCriteria['allgemeintoleranzen'][1] : '';
        } catch (e) {
            items['allgemeintoleranzen'][1] = '';
        }
        try {
            items['iso_toleranzen'][0] = this.producerUser?.abilities?.qualityCriteria['iso_toleranzen'][0] ? this.producerUser?.abilities?.qualityCriteria['iso_toleranzen'][0] : '';
        } catch (e) {
            items['iso_toleranzen'][0] = '';
        }

        this.form.qualityCriteria = items;
        this.labels.qualityCriteriaLabels = labels;

        // define formTolerance
        items = {};
        labels = {};
        this.abilities.formTolerance.forEach((formTolerance) => {
            try {
                items[formTolerance[0]] = this.producerUser.abilities?.formTolerance[formTolerance[0]] ? this.producerUser.abilities?.formTolerance[formTolerance[0]] : '';
            } catch (e) {
                items[formTolerance[0]] = '';
            }
            labels['_' + formTolerance[0]] = formTolerance[1];
        });

        this.form.formTolerance = items;
        this.labels.formToleranceLabels = labels;

        // define positionTolerance
        items = {};
        labels = {};
        this.abilities.positionTolerance.forEach((positionTolerance) => {
            try {
                items[positionTolerance[0]] = this.producerUser.abilities?.positionTolerance[positionTolerance[0]] ? this.producerUser.abilities?.positionTolerance[positionTolerance[0]] : '';
            } catch (e) {
                items[positionTolerance[0]] = '';
            }
            labels['_' + positionTolerance[0]] = positionTolerance[1];
        });

        this.form.positionTolerance = items;
        this.labels.positionToleranceLabels = labels;

        this.$emit('update:modelValue', this.form);
    },
};
</script>
